<template>
  <div>  
    <div v-if="loading" class="row">
			<div class="col-md-12">
				<spinner></spinner>
			</div>
		</div>

    <div v-else id="account-details">
      <div class="login">        
        <div class="login_form_container">
          <div class="account_login_form">
            <h5 class="mb-20">{{ $t('Perfil de Usuario') }}</h5>
            <form action="#">
              <div class="row">
                <div class="col-md-6 offset-md-0">
                  <label class="">{{ $t('Nombre de Usuario') }}</label>
                  <input v-model="user.usr_login" type="text" class="blocked" disabled>  

                  <label class="">{{ $t('Empresa') }}</label>
                  <input v-model="user.usr_company" type="text" name="first-name">
                  <!-- <label>Persona de contacto</label>
                  <input type="text" name="last-name"> -->
                  <label>{{ $t('Teléfono') }}</label>
                  <input v-model="user.usr_phone" type="text" name="email-name">
                  <label>{{ $t('Email') }}</label>
                  <input v-model="user.usr_email" type="text" name="email-name">
                  <div class="login_submit mt-20">
                    <button>{{ $t('Guardar') }}</button>
                  </div>
                </div> 
                <div class="col-md-5 offset-md-1">
                  <label>Último login</label>
                  <input v-model="user.usr_last_login_date" type="text" class="text-right pr-10 blocked" disabled>
                  <label>IP</label>
                  <input v-model="user.usr_last_login_ip" type="text" class="text-right pr-10 blocked" disabled>
                </div>               
              </div>              
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
  {
    "es" :{
      "Perfil de Usuario": "Perfil de Usuario",
      "Nombre de Usuario": "Nombre de Usuario",
      "Empresa": "Empresa",
      "Teléfono": "Teléfono",
      "Email": "Email",
      "Guardar": "Guardar"
    },
    "en" :{
      "Perfil de Usuario": "User profile",
      "Nombre de Usuario": "Username",
      "Empresa": "Company",
      "Teléfono": "Phone",
      "Email": "Email",
      "Guardar": "Save"
    }
  }
</i18n>

<script>
  import Spinner from './helpers/Spinner.vue';

	import { mapGetters } from 'vuex';
	import { mixinGlobal } from './../mixins/mixinGlobal';

  export default {
    components: { Spinner },
    mixins: [ mixinGlobal ],
    data () {
	    return {
        loading: false,
        user: {
					usr_login: 'acciona',
					usr_company: 'Acciona',
					usr_email: 'punchout@acciona.com',
					usr_phone: '91 123 12 12',
					usr_last_login_ip: '10.0.0.1',
					usr_last_login_date: '11-11-2019 17:50:30'
        }
      }
    },
    mounted () {
      this.loadData();
    },
    computed: {
      ...mapGetters( ['getApiUrl'] ),
    },
    methods: {
      loadData() {
        this.startLoading();

        this.$axios.get(this.getApiUrl + 'productos.php')
        .then( (respuesta) =>{  
          if( this.checkResponseData(respuesta.data) ){
						//this.user = respuesta.data.data;
					}else{
						this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message: respuesta.data } )
					}  
          this.stopLoading();
        })  
        .catch( (error) =>{ 
					let  message = '';
					if (error.response.data.hasOwnProperty('message')) {
						message = error.response.data.message;
					}else{
						message = error
					}
					this.$store.commit('mutateGlobalMessage', { toast: false, icon: 'error', title: this.$t('Error'), message:   message } )
					this.stopLoading();
        })        
      }
    },
  }
</script>

<style type="text/css">
  .blocked{ background: #eceff8 !important; cursor: not-allowed !important; }
</style>